// extracted by mini-css-extract-plugin
export var headerXL = "SectionPricingFeatureTable-module--headerXL--tM-Ca";
export var headerL = "SectionPricingFeatureTable-module--headerL--DuR-y";
export var headerM = "SectionPricingFeatureTable-module--headerM--2mrlp";
export var headerS = "SectionPricingFeatureTable-module--headerS--czfwI";
export var headerXS = "SectionPricingFeatureTable-module--headerXS--EjgIh";
export var blogHeaderXL = "SectionPricingFeatureTable-module--blogHeaderXL--3fGMU";
export var blogHeaderL = "SectionPricingFeatureTable-module--blogHeaderL--CLdhf";
export var blogHeaderM = "SectionPricingFeatureTable-module--blogHeaderM--2nZ5A";
export var blogHeaderS = "SectionPricingFeatureTable-module--blogHeaderS--Rpv5X";
export var blogHeaderXS = "SectionPricingFeatureTable-module--blogHeaderXS--3iwd8";
export var headerPreamble = "SectionPricingFeatureTable-module--headerPreamble--eo29n";
export var preHeader = "SectionPricingFeatureTable-module--preHeader--wDD7r";
export var textNormal = "SectionPricingFeatureTable-module--textNormal--2p0bA";
export var textSmall = "SectionPricingFeatureTable-module--textSmall--IcXHv";
export var textSmallAlternate = "SectionPricingFeatureTable-module--textSmallAlternate--1GPhh";
export var legend = "SectionPricingFeatureTable-module--legend--9HUvW";
export var caption = "SectionPricingFeatureTable-module--caption--rzpb_";
export var gradientBackground = "SectionPricingFeatureTable-module--gradientBackground--31PI3";
export var ellipsis = "SectionPricingFeatureTable-module--ellipsis--2JaKw";
export var globalContainer = "SectionPricingFeatureTable-module--globalContainer--19R-H";
export var maxWidth = "SectionPricingFeatureTable-module--maxWidth--3CJci";
export var clipBottom = "SectionPricingFeatureTable-module--clipBottom--2asMl";
export var clipTopBottom = "SectionPricingFeatureTable-module--clipTopBottom--2GMQ6";
export var pricingFeatureTableSection = "SectionPricingFeatureTable-module--pricingFeatureTableSection--1jUGG";
export var container = "SectionPricingFeatureTable-module--container--2B0yJ";
export var table = "SectionPricingFeatureTable-module--table--1V_kF";
export var row = "SectionPricingFeatureTable-module--row--2K89P";
export var line = "SectionPricingFeatureTable-module--line--1MIw9";
export var titleField = "SectionPricingFeatureTable-module--titleField--2BMdD";
export var title = "SectionPricingFeatureTable-module--title--139_z";
export var featureTitle = "SectionPricingFeatureTable-module--featureTitle--2XW8x";
export var listItem = "SectionPricingFeatureTable-module--listItem--tKFVu";
export var column = "SectionPricingFeatureTable-module--column--1ZPTy";
export var columnTitle = "SectionPricingFeatureTable-module--columnTitle--xFA2E";
export var checkField = "SectionPricingFeatureTable-module--checkField--1Tyg8";
export var firstField = "SectionPricingFeatureTable-module--firstField--30H23";
export var lastField = "SectionPricingFeatureTable-module--lastField--10bAa";
export var ch2 = "SectionPricingFeatureTable-module--ch2--1tq-p";
export var ch2Container = "SectionPricingFeatureTable-module--ch2-container--1qQPb";